import clsx from 'clsx'
import Image from 'next/image'
import { StaticImageData } from 'next/image'
import { ReactNode } from 'react'

export interface Author {
  name: string;
  title: string;
  avatar: StaticImageData;
  bio?: string | ReactNode;
}

interface AuthorsProps {
  authors: Author[];
}

export function AuthorsMini({ authors }: AuthorsProps) {
  return (
    <ul className={clsx('-mx-5 -mt-6 flex flex-wrap text-sm leading-6')}>
      {authors.map((author) => (
        <li
          key={author.title}
          className="mt-6 flex items-center px-5 font-medium"
        >
          <Image
            src={author.avatar}
            className="mr-3 h-10 w-10 rounded-full"
            alt=""
            unoptimized // required to force NextJS to not use the custom cloudflare loader
            priority
          />
          <div className="leading-4">
            <div className="text-md text-slate-200">{author.name}</div>
            <div className="text-sm text-sky-400">{author.title}</div>
          </div>
        </li>
      ))}
    </ul>
  )
}

export function AuthorsFull({ authors }: AuthorsProps) {
  return (
    <div className="mt-12 flex flex-wrap gap-y-2">
      {authors.map((author) => (
        <div
          key={author.title}
          className="flex w-full rounded-lg border border-gray-700 bg-gray-800 px-4 py-4 shadow-lg md:px-8"
        >
          <div className="flex flex-wrap gap-x-4 gap-y-4 md:flex-nowrap">
            <Image
              src={author.avatar}
              className="h-20 w-20 rounded-full"
              alt=""
              unoptimized // required to force NextJS to not use the custom cloudflare loader
              priority
            />
            <div>
              <div className="text-xl font-medium text-slate-200">
                {author.name}
              </div>
              <div className="text-md font-semibold text-sky-400">
                {author.title}
              </div>
              <div className="text-md mt-3 text-slate-200">{author.bio}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}